import React from "react";
import { NavLink, useLocation, Location } from "react-router-dom";

interface NavbarItemProps {
  link: string;
  icon: React.ReactNode;
  label: string | null;
  replace?: boolean;
  onClick?: () => void;
  isActive?: (location: Location) => boolean;
  compact?: boolean;
}

const NavbarItem: React.FC<NavbarItemProps> = ({
  link,
  icon,
  label,
  replace,
  onClick,
  isActive,
  compact = false,
}) => {
  const location = useLocation();

  return (
    <NavLink
      to={link}
      className={({ isActive: navIsActive }) => {
        const active = isActive ? isActive(location) : navIsActive;
        return `block w-full p-1 my-2 rounded ${compact ? "text-sm" : ""} ${
          active ? "bg-[#E7E5E0] " : "bg-white"
        } hover:bg-[#E7E5E0] hover:`;
      }}
      onClick={onClick}
      reloadDocument={replace}
    >
      <div
        className={`flex flex-row items-center justify-start ${
          compact ? "space-x-2" : "space-x-3"
        }`}
      >
        <div className={`${compact ? "h-6 w-6" : "h-8 w-8"} lg:m-auto`}>
          {icon}
        </div>
        {label ? (
          <h6 className={`w-3/4 ${compact ? "text-xs" : "text-sm"}`}>
            {label}
          </h6>
        ) : (
          <></>
        )}
      </div>
    </NavLink>
  );
};

export default NavbarItem;
